"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onBFCacheRestore = onBFCacheRestore;
const browser_core_1 = require("@datadog/browser-core");
function onBFCacheRestore(configuration, callback) {
    const { stop } = (0, browser_core_1.addEventListener)(configuration, window, "pageshow" /* DOM_EVENT.PAGE_SHOW */, (event) => {
        if (event.persisted) {
            callback(event);
        }
    }, { capture: true });
    return stop;
}
//# sourceMappingURL=bfCacheSupport.js.map